<button
    type="button"
    class="min-h-10 min-w-10 text-xl leading-normal text-gray-500 transition-all"
    mat-flat-button
    [attr.aria-label]="ariaLabel()"
    [routerLink]="route()"
    [queryParams]="queryParams()"
    (click)="clicked.emit()"
>
    <fa-icon [icon]="icons.chevronLeft" size="1x" aria-hidden="true"></fa-icon>
</button>
